import { Text } from '@logz-ui/styleguide';
import { SneakPeakBanner } from 'ui/components/App/SneakPeakBanners/SneakPeakBanner';
import { exploreRouteNames } from 'states/explore/explore.route.names';

export const ExploreSneakPeakBanner = () => {
  return (
    <SneakPeakBanner
      textComponent={
        <Text>
          See the new <b>Open 360 AI Experience</b>
        </Text>
      }
      allowedStates={[exploreRouteNames.explore]}
    />
  );
};
